import React from "react";
import styled from "styled-components";
import { Spacer, Grid, Text, FormSelect, FormLabel, FormDate, IconButton, useModal, FormInput } from "@holta/ui";
import { Link } from "raviger";
import { useStore } from "../../../hooks/useStore";
import {setCategoriesSearchFilter} from '../../../actions/ui';
import {useModalCategoryContext} from '../../../components/ModalCategory/context';
import { fns } from "@holta/lib";
import {user} from '../../../fns/user';
import {saveCategory} from '../../../actions/categories';
interface Props {}

export const Header: React.FC<Props> = () => {

    const { openModalCategory } = useModalCategoryContext();

    const searchFilter = useStore(store => store.ui.categories.searchFilter);

    return (
        <Spacer xs={[2]}>
            <Grid.Row xs={{ justify: "space-between", align: "center" }}>
                <Grid.Col>
                    <Text size="xl">Categories</Text>
                </Grid.Col>
                <Grid.Col>
                    <button className="primary" onClick={() => openModalCategory(fns.category.create(user.id as string), true, saveCategory, () => {})}>New Category</button>
                </Grid.Col>
            </Grid.Row>
            <Spacer xs={[1]}></Spacer>
            <Grid.Row xs={{ justify: "space-between" }}>
                <Grid.Col>
                    <Grid.Row>
                        <div>
                            <FormInput placeholder="Search..." value={searchFilter} onChange={e => setCategoriesSearchFilter(e.target.value)}/>
                        </div>
                    </Grid.Row>
                </Grid.Col>
            </Grid.Row>
        </Spacer>
    );
};
